import React from "react";

export default function EditCircleIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="#ECECEC" />
      <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="white" />
      <mask
        id="mask0_110_511"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="5"
        y="5"
        width="22"
        height="22"
      >
        <rect
          x="5.33301"
          y="5.33337"
          width="21.3333"
          height="21.3333"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_110_511)">
        <path
          d="M9.77778 22.2222H11.0444L19.7333 13.5333L18.4667 12.2667L9.77778 20.9556V22.2222ZM8 24V20.2222L19.7333 8.51111C19.9111 8.34815 20.1074 8.22222 20.3222 8.13333C20.537 8.04444 20.763 8 21 8C21.237 8 21.4667 8.04444 21.6889 8.13333C21.9111 8.22222 22.1037 8.35556 22.2667 8.53333L23.4889 9.77778C23.6667 9.94074 23.7963 10.1333 23.8778 10.3556C23.9593 10.5778 24 10.8 24 11.0222C24 11.2593 23.9593 11.4852 23.8778 11.7C23.7963 11.9148 23.6667 12.1111 23.4889 12.2889L11.7778 24H8ZM19.0889 12.9111L18.4667 12.2667L19.7333 13.5333L19.0889 12.9111Z"
          fill="#3C3C3C"
        />
      </g>
    </svg>
  );
}
